import { writable } from 'svelte/store';

export const confirmStore = writable(null);

const DEFAULT_OPTIONS = {
    type: 'info',
    title: 'Confirmation',
    message: '',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    closeOnBackdrop: true,
    closeOnEscape: true,
    width: 420
};

function show(options = {}) {
    return new Promise((resolve) => {
        confirmStore.set({
            ...DEFAULT_OPTIONS,
            ...options,
            resolve
        });
    });
}

export const confirm = show;

export const ui = {
    info(message, title = 'Information') {
        return show({
            type: 'info',
            title,
            message,
            confirmText: 'OK',
            cancelText: ''
        });
    },

    warning(message, title = 'Warning') {
        return show({
            type: 'warning',
            title,
            message,
            confirmText: 'Continue'
        });
    },

    delete(message, title = 'Delete') {
        return show({
            type: 'delete',
            title,
            message,
            confirmText: 'Delete'
        });
    }
};